export const TIME_UNIT_BY_DAYS = {
  week: 7,
  month: 30,
  year: 360,
};
